export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-3xl font-black text-fg mb-2">Политика конфиденциальности</h1>
      <p className="text-sm text-muted mb-10">vaumanga.com</p>

      <div className="flex flex-col gap-8">
        <Section title="1. Общие положения">
          <p>Настоящая Политика конфиденциальности описывает, какие данные мы собираем, как используем и защищаем их при использовании сайта vaumanga.com. Используя сайт, вы соглашаетесь с условиями данной политики.</p>
        </Section>

        <Section title="2. Какие данные мы собираем">
          <p>При регистрации:</p>
          <ul>
            <li>Email-адрес</li>
            <li>Никнейм</li>
            <li>Аватар (если загружаете)</li>
            <li>Пароль (хранится только в зашифрованном виде, оригинал нам недоступен)</li>
          </ul>
          <p>Автоматически при использовании сайта:</p>
          <ul>
            <li>IP-адрес</li>
            <li>Тип браузера и устройства</li>
            <li>История просмотров (для работы закладок и прогресса чтения)</li>
            <li>Дата и время посещений</li>
          </ul>
        </Section>

        <Section title="3. Как мы используем ваши данные">
          <p>Собранные данные используются для:</p>
          <ul>
            <li>Создания и управления вашим аккаунтом</li>
            <li>Сохранения закладок и прогресса чтения</li>
            <li>Возможности писать комментарии</li>
            <li>Отправки писем сброса пароля</li>
            <li>Модерации: рассмотрения жалоб и блокировки нарушителей</li>
          </ul>
        </Section>

        <Section title="4. Комментарии">
          <p>Комментарии публичны и видны всем пользователям. Мы оставляем за собой право удалять комментарии и блокировать пользователей, нарушающих правила сайта.</p>
        </Section>

        <Section title="5. Аватары и загружаемые материалы">
          <p>Загружая аватар, вы подтверждаете, что имеете право на использование данного изображения. Мы вправе удалить аватар, нарушающий правила сообщества.</p>
        </Section>

        <Section title="6. Передача данных третьим лицам">
          <p>Мы не продаём и не передаём ваши данные третьим лицам, за исключением:</p>
          <ul>
            <li>Resend — сервис доставки email, получает ваш адрес исключительно для отправки транзакционных писем (сброс пароля)</li>
          </ul>
        </Section>

        <Section title="7. Cookies">
          <p>Мы используем cookies для поддержания сессии (чтобы вы оставались в системе) и сохранения пользовательских настроек. Рекламные cookies не используются.</p>
        </Section>

        <Section title="8. Хранение данных">
          <p>Ваши данные хранятся, пока ваш аккаунт активен. Вы можете запросить удаление аккаунта и всех связанных данных, написав на <a href="mailto:dmca@vaumanga.com" className="text-accent hover:underline">dmca@vaumanga.com</a>.</p>
        </Section>

        <Section title="9. Безопасность">
          <p>Мы принимаем разумные меры для защиты ваших данных. Пароли хранятся в зашифрованном виде. Тем не менее ни один сайт не может гарантировать абсолютную защиту данных.</p>
        </Section>

        <Section title="10. Ваши права">
          <p>Вы имеете право:</p>
          <ul>
            <li>Получить доступ к своим персональным данным</li>
            <li>Запросить исправление или удаление данных</li>
            <li>Отозвать согласие на обработку данных</li>
          </ul>
          <p>Для любых запросов: <a href="mailto:dmca@vaumanga.com" className="text-accent hover:underline">dmca@vaumanga.com</a></p>
        </Section>

        <Section title="11. Изменения политики">
          <p>Мы можем обновлять данную политику. Продолжение использования сайта после изменений означает ваше согласие с обновлённой версией.</p>
        </Section>

        <Section title="12. Контакты">
          <p>По всем вопросам конфиденциальности: <a href="mailto:dmca@vaumanga.com" className="text-accent hover:underline">dmca@vaumanga.com</a></p>
        </Section>
      </div>

      <p className="text-xs text-muted mt-12 pt-6 border-t border-line">Последнее обновление: май 2026</p>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-base font-bold text-accent">{title}</h2>
      <div className="flex flex-col gap-2 text-sm text-fg leading-relaxed [&_ul]:flex [&_ul]:flex-col [&_ul]:gap-1.5 [&_ul]:pl-1 [&_li]:flex [&_li]:gap-2 [&_li]:before:content-['—'] [&_li]:before:text-muted [&_li]:before:flex-shrink-0">
        {children}
      </div>
    </section>
  )
}
